<template>
  <RouterView />
</template>

<script setup>
import { RouterView } from 'vue-router'
import { onMounted } from 'vue'
import { useThemeStore } from './stores/theme'

const themeStore = useThemeStore()

onMounted(() => {
  // Apply theme on mount
  themeStore.applyTheme()

  // Log app initialization
  console.log('[App] POS Vue application initialized')
  console.log('[App] Database:', window.posDB ? 'Ready' : 'Not ready')
  console.log('[App] API Interceptor:', window.apiInterceptor ? 'Active' : 'Inactive')
})
</script>

<style>
/* Global Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-family, 'Inter', sans-serif);
  background-color: var(--bg-primary, #f1f5f9);
  color: var(--text-primary, #1e293b);
  font-size: var(--font-size-base, 14px);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  width: 100%;
  min-height: 100vh;
}

/* Network Status Indicator Styles */
#network-status {
  position: fixed;
  top: 10px;
  right: 10px;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: bold;
  font-family: system-ui, -apple-system, sans-serif;
  font-size: 14px;
  z-index: 10000;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

#network-status.online {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

#network-status.offline {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

/* PWA Install Prompt */
#install-prompt {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: #007bff;
  color: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  display: none;
  z-index: 10001;
  font-family: system-ui, -apple-system, sans-serif;
}

#install-prompt button {
  background: white;
  color: #007bff;
  border: none;
  padding: 8px 16px;
  margin-left: 12px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

#install-prompt button:hover {
  background: #f0f0f0;
}
</style>
